import React from 'react'
import PropTypes from 'prop-types'

import { Filters } from 'components'
import constants from 'constants/index'

const PhishingFilters = ({ filter }) => {
  return (
    <Filters filter={filter}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Nome da campanha" name="name" />
      <input textfieldinput="true" label="Nome do modelo" name="templateName" />
      <select textfieldinput="true" label="Status" name="status">
        <option value="" />
        {Object.entries(constants.phishing.STATUS_LABEL).map(
          ([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ),
        )}
      </select>
      <select
        textfieldinput="true"
        label="Tipo de agendamento"
        name="scheduleType"
      >
        <option value="" />
        {constants.phishing.DISPATCH_OPTIONS.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </Filters>
  )
}

PhishingFilters.propTypes = {
  filter: PropTypes.object.isRequired,
}

export default PhishingFilters
